import React from 'react';
import { useIntl } from 'ha/i18n';
import { UserAvatar } from 'ha/ui/UserAvatar';
import { Grid, Typography } from '@ha/dsl';

import { ReadingTime } from 'ha/modules/Contentful/utils';
import { Author } from '../types';

interface Props {
  author: Author;
  readingTime: ReadingTime;
  isUpdated?: boolean;
}

const BlogAuthorCard: React.FC<Props> = ({
  author: { name, date, avatar, avatarAsset },
  readingTime,
  isUpdated = false,
}) => {
  const { T, formatDate } = useIntl();
  const formatedDate = formatDate('MMM DD', date);
  const separator = String.fromCharCode(8226);

  let note = formatedDate;

  if (!readingTime.hide) {
    const time = T('%s min read', readingTime.timeLength);

    note = `${formatedDate} ${separator} ${time}`;
  }

  return (
    <Grid
      container
      alignItems="center"
      spacing={1}
      data-test-locator="Blog Author Card"
    >
      <Grid item>
        <UserAvatar
          src={avatarAsset ? avatarAsset.fields.url : avatar}
          data-test-locator="Blog Author Avatar"
        />
      </Grid>
      <Grid item>
        <Typography.H4 data-test-locator="Blog Author Name">
          {name}
        </Typography.H4>

        <Typography.Caption data-test-locator="Blog Author Note">
          {isUpdated ? `${T('blog_author_card_updated_text')} ${note}` : note}
        </Typography.Caption>
      </Grid>
    </Grid>
  );
};

export { BlogAuthorCard };
